import { render, staticRenderFns } from "./agency_check-record-detail.vue?vue&type=template&id=0e8132d0&scoped=true"
import script from "./agency_check-record-detail.vue?vue&type=script&lang=ts"
export * from "./agency_check-record-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8132d0",
  null
  
)

export default component.exports